import {ValidationError, ValidationErrorType} from "../ValidationTypes";
import {validateTrusts} from "../distribution/TrustValidator";
import {validateCharities} from "../distribution/CharityValidator";
import {filterCharities, filterOutrights, filterTrusts, EVENT_NAME_MAX_LENGTH, isValid} from "../ValidationUtils";
import {AdditionalDistributionLayer, Distribution} from "../../model/EstateFlowchartTypes";
import {validateOutrights} from "../distribution/OutrightValidator";

export const validateRemainderBeneficiaries = (
    distributions: Distribution[],
    enableEstateFlowchartMVPRelease: boolean,
    additionalDistributions?: AdditionalDistributionLayer
): ValidationError[] => {
    let validationErrors: ValidationError[] = [];

    if (distributions && distributions.length > 0) {
        validationErrors = validationErrors.concat(validateTrusts(filterTrusts(distributions)));
        validationErrors = validationErrors.concat(validateCharities(filterCharities(distributions), enableEstateFlowchartMVPRelease));
        validationErrors = validationErrors.concat(validateOutrights(filterOutrights(distributions)));
    }

    validationErrors = validationErrors.concat(validateAdditionalDistributionLayer(additionalDistributions));

    return validationErrors;
}

const validateAdditionalDistributionLayer = (
    additionalDistributions?: AdditionalDistributionLayer
): ValidationError[] => {
    if (!additionalDistributions) {
        return [];
    }

    const errors: ValidationError[] = [];
    const eventTextRaw = additionalDistributions.triggerEventText ?? "";
    const eventTextTrimmed = eventTextRaw.trim();
    const isMemberRequired = additionalDistributions.triggerEventType === "DEATH"
        || additionalDistributions.triggerEventType === "AGE_ATTAINMENT";
    const isAgeRequired = additionalDistributions.triggerEventType === "AGE_ATTAINMENT";
    const isEventTextRequired = additionalDistributions.triggerEventType === "OTHER";

    if (!isValid(additionalDistributions.triggerEventType)) {
        return errors;
    }

    const hasMemberSelection = isValid(additionalDistributions.triggerMemberId)
        || isValid(additionalDistributions.triggerMemberName);

    if (isMemberRequired && !hasMemberSelection) {
        errors.push({
            type: ValidationErrorType.REQUIRED_FIELDS,
            property: "triggerMemberId",
            parent: "Additional Distribution",
            error: "Member is required."
        });
    }

    if (isAgeRequired
        && (additionalDistributions.triggerAge === null || additionalDistributions.triggerAge === undefined)) {
        errors.push({
            type: ValidationErrorType.REQUIRED_FIELDS,
            property: "triggerAge",
            parent: "Additional Distribution",
            error: "Age must be a number greater than 0"
        });
    } else if (isAgeRequired
        && additionalDistributions.triggerAge !== null
        && additionalDistributions.triggerAge !== undefined
        && additionalDistributions.triggerAge <= 0) {
        errors.push({
            type: ValidationErrorType.INVALID_CHARACTERS,
            property: "triggerAge",
            parent: "Additional Distribution",
            error: "Age must be a number greater than 0"
        });
    }

    if (isEventTextRequired && eventTextRaw.length > EVENT_NAME_MAX_LENGTH) {
        errors.push({
            type: ValidationErrorType.INVALID_CHARACTERS,
            property: "triggerEventText",
            parent: "Additional Distribution",
            error: `Event Name cannot exceed ${EVENT_NAME_MAX_LENGTH} characters`
        });
    } else if (isEventTextRequired && !isValid(eventTextTrimmed)) {
        errors.push({
            type: ValidationErrorType.REQUIRED_FIELDS,
            property: "triggerEventText",
            parent: "Additional Distribution",
            error: "Event name is required."
        });
    }

    return errors;
}

